import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchWindRoseData } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const WindRoseChartSlice: Slice<any, {}, "WindRose"> = createSlice({
    name: "WindRose",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchWindRoseData.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchWindRoseData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchWindRoseData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default WindRoseChartSlice
